export default function formatUSD(amount, { showDecimal = false } = {}) {
	return new Intl.NumberFormat("en-US", {
		style: "currency",
		currency: "USD",
		maximumFractionDigits: showDecimal ? 2 : 0,
		minimumFractionDigits: showDecimal ? 2 : 0
	}).format(amount);
}
